module.exports = __webpack_public_path__ + "static/media/screenshot.f031172f.png";